import { BACK_TARGETS } from '@/context/transaction/common';
import { TransactionBackTarget } from '@/context/transaction/types';
import { findTypedKey } from '@/utils';

export const useBackTargetForCurrentPage = (): TransactionBackTarget | null =>
    findTypedKey(BACK_TARGETS, ({ href }) => location.pathname.match(new RegExp(`${href}\\b`))) ?? null;
